import { Button, Menu } from '@kula-ai/components';
import { ChevronDown } from '@kula-ai/icons-core';
import type { WorkdayHireType } from './hireType';

export interface WorkdayHireMenuProps {
  /** Display name of the connector, so the button reads as its own action. */
  integrationName?: string;
  onSelect: (_hireType: WorkdayHireType) => void;
  isLoading?: boolean;
  loadingText?: string;
  variant?: 'primary' | 'tertiary';
}

/**
 * "Add to Workday" with the two hire types behind it.
 *
 * One control rather than two buttons: the recruiter is picking *how* to do
 * one action, not choosing between two. It also matches the "Add to HRIS"
 * menu they already use, so the shape is familiar.
 *
 * Shared because three surfaces offer this — the hired-stage card, and the
 * modal's single- and multi-integration views — and two of them sit beside
 * each other in the same flow.
 */
export const WorkdayHireMenu = ({
  integrationName = 'Workday',
  onSelect,
  isLoading = false,
  loadingText,
  variant = 'primary',
}: WorkdayHireMenuProps) => (
  <Menu
    align="end"
    items={[
      {
        key: 'new_hire',
        label: 'New hire',
        onClick: () => onSelect('new_hire'),
      },
      { key: 'rehire', label: 'Rehire', onClick: () => onSelect('rehire') },
    ]}
    trigger={
      <Button
        size="sm"
        variant={variant}
        isLoading={isLoading}
        loadingText={loadingText}
        rightElement={<ChevronDown size={16} />}
      >
        {`Add to ${integrationName}`}
      </Button>
    }
  />
);

export default WorkdayHireMenu;
